import type { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuthStore } from '../auth/store';

export function RequireAuth({ children }: { children: ReactNode }): JSX.Element {
  const me = useAuthStore((s) => s.me);
  const loading = useAuthStore((s) => s.loading);

  if (loading) {
    return (
      <div style={{ padding: 'var(--space-8)', textAlign: 'center' }}>
        Loading…
      </div>
    );
  }
  if (!me) return <Navigate to="/login" replace />;
  return <>{children}</>;
}
